<template>
  <sustainability />
</template>
